/** Scoped to one mounted owner, never shared between users. Settled responses are
 * not cached: refresh/retry must be able to issue a new request. */
export class PendingRequests {
  private readonly requests = new Map<string, Promise<unknown>>();

  run<T>(key: string, fetch: () => Promise<T>): Promise<T> {
    const existing = this.requests.get(key);
    if (existing) return existing as Promise<T>;
    const promise = fetch();
    this.requests.set(key, promise);
    const remove = () => this.requests.delete(key);
    void promise.then(remove, remove);
    return promise;
  }
}
